module.exports = __webpack_public_path__ + "img/btn.c679e5a7.png";